import React, { createContext, useContext, useState } from "react";
import { ICompanyDetailsContext, ICompanyDetailsData } from "../exports/interfaces";

const CompanyDetailsContext = createContext<ICompanyDetailsContext>({
  companyDetailsData: [],
  setCompanyDetailsData: () => null,
});
export const useCompanyDetailsContext = () => useContext(CompanyDetailsContext);

export const CompanyDetailsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [companyDetailsData, setCompanyDetailsData] = useState<ICompanyDetailsData[]>([]);

  return (
    <CompanyDetailsContext.Provider
      value={{ companyDetailsData, setCompanyDetailsData }}
    >
      {children}
    </CompanyDetailsContext.Provider>
  );
};
